import type { AllRouteEndpoints } from "../routeTypes";
export const BlankCanvasTemplateCacheKeys: AllRouteEndpoints[] = [];
